import { ProductFamilyIds } from "../../Products/constants";
import PhoneSystemTerms from "./PhoneSystemTerms";
import PurchaseBar from "../../Products/PurchaseBar";
import PurchaseIframe from "../../Products/PurchaseIframe";
import { PhonePlusSolidV6 } from "@shared/v2/Icomoon";

const PhoneSystemPurchase = () => (
  <PurchaseIframe src="https://www.brivity.com/phone-system-in-app" title="Phone System Add-On">
    <PurchaseBar
      title="Route and track your inbound calls, right from your CRM"
      productFamilySlug={ProductFamilyIds.PhoneSystem}
      step1Children={
        <p className="tw-w-full tw-mt-[32px] tw-mb-[12px] tw-text-14d tw-text-center tw-text-gray-50 tw-italic">
          *Need more than 10 numbers? Purchase additional numbers as needed for <b>$5 / line</b> on the{" "}
          <b>Enterprise Plan only</b>
        </p>
      }
      terms={<PhoneSystemTerms />}
      completeModalProps={{
        Icon: PhonePlusSolidV6,
        title: "Congratulations on unlocking Phone System!",
        description:
          "Phone System is now ready to set up - click “get started” to create your first tracking number.",
        url: "/phone_system?view=logs",
      }}
    />
  </PurchaseIframe>
);

export default PhoneSystemPurchase;
